import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Compass, BookOpen } from 'lucide-react';
export function Services() {
  return <section id="sesiones" className="w-full bg-white py-24 px-6 scroll-mt-8" data-id="element-396">
      <div className="max-w-7xl mx-auto" data-id="element-397">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-398">
          <h2 className="font-serif text-teal text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-399">
            Sesiones disponibles
          </h2>
          <p className="font-serif italic text-gray-500 text-xl" data-id="element-400">
            Tres niveles. Un mismo método.
            <br data-id="element-401" />
            La profundidad que cada momento necesita.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch mb-12" data-id="element-402">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="flex flex-col bg-white border border-teal rounded-2xl p-8 relative" data-id="element-403">
            <div className="w-14 h-14 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-404">
              <Sparkles className="text-teal" size={26} strokeWidth={1.5} data-id="element-405" />
            </div>
            <div className="text-teal font-serif uppercase tracking-widest text-xs mb-6" data-id="element-406">
              El punto de entrada natural
            </div>
            <h3 className="font-serif text-teal text-2xl mb-4" data-id="element-407">
              Depuración Energética Esencial
            </h3>
            <p className="text-gray-700 font-light mb-8 flex-grow leading-relaxed" data-id="element-408">
              Una sesión de depuración y restauración del campo áurico con
              péndulo hebreo.
              <br data-id="element-409" />
              <br data-id="element-410" />
              Un proceso más acotado que los otros dos niveles — enfocado,
              preciso, con un objetivo claro: liberar cargas, bloqueos y
              perturbaciones del campo que están interfiriendo en tu estado
              actual.
            </p>
            <ul className="space-y-3 text-gray-700 font-light mb-8" data-id="element-411">
              <li className="flex items-start gap-2" data-id="element-412">
                <span className="text-gold" data-id="element-413">✦</span> Trabajo con péndulo hebreo
              </li>
              <li className="flex items-start gap-2" data-id="element-414">
                <span className="text-gold" data-id="element-415">✦</span> Depuración del campo áurico
              </li>
              <li className="flex items-start gap-2" data-id="element-416">
                <span className="text-gold" data-id="element-417">✦</span> Audio de devolución
                personalizado (aprox. 30 min)
              </li>
            </ul>
            <div className="border-t border-teal/20 pt-6 mb-8" data-id="element-418">
              <div className="text-teal font-medium text-lg mb-1" data-id="element-419">
                🇦🇷 $70.000 ARS
              </div>
              <div className="text-teal font-medium text-lg" data-id="element-420">
                🌎 USD 50 vía PayPal
              </div>
            </div>
            <div className="border-t border-teal/20 pt-6 mb-8" data-id="element-421">
              <div className="text-teal font-medium text-lg mb-1" data-id="element-422">
                PARA QUIÉN ES
              </div>
              <div className="text-gray-700 font-light italic" data-id="element-423">
                Quienes sienten pesadez, estancamiento o que algo no fluye — sin
                necesariamente saber qué ni por qué. También es el punto de
                entrada natural si es tu primera vez con este tipo de trabajo.
              </div>
            </div>
            <a href="https://wa.me/542616167908?text=Hola%20Laura!%20Quiero%20agendar%20una%20sesi%C3%B3n%20de%20Depuraci%C3%B3n%20Energ%C3%A9tica%20Esencial." target="_blank" rel="noopener noreferrer" className="w-full text-center bg-teal text-white py-4 rounded-full font-medium tracking-wide hover:bg-teal-dark transition-colors" data-id="element-424">
              AGENDAR SESIÓN
            </a>
          </motion.div>

          {/* Card 2 - Highlighted */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col bg-teal rounded-2xl p-8 relative lg:scale-105 shadow-xl z-10" data-id="element-425">
            <div className="absolute top-0 right-0 bg-gold text-teal text-xs font-bold px-4 py-1 rounded-bl-xl rounded-tr-xl tracking-wider" data-id="element-426">
              MÁS ELEGIDA
            </div>
            <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center mb-6 mt-2" data-id="element-427">
              <Compass className="text-gold" size={26} strokeWidth={1.5} data-id="element-428" />
            </div>
            <div className="text-gold font-serif uppercase tracking-widest text-xs mb-6" data-id="element-429">
              Profundidad y precisión
            </div>
            <h3 className="font-serif text-white text-2xl mb-4" data-id="element-430">
              Depuración + Investigación Radiestésica
            </h3>
            <p className="text-white/90 font-light mb-8 flex-grow" data-id="element-431">
              Antes de trabajar el campo, lo leo en profundidad con herramientas
              de radiestesia.
              <br data-id="element-432" />
              <br data-id="element-433" />
              Identifico qué tipo de perturbaciones hay, en qué zonas del campo
              están más presentes, qué naturaleza tienen y cómo se relacionan
              con lo que estás viviendo.
              <br data-id="element-434" />
              <br data-id="element-435" />
              Luego depuro con la precisión que solo da saber exactamente dónde
              y cómo operar.
            </p>
            <ul className="space-y-3 text-white font-light mb-8" data-id="element-436">
              <li className="flex items-start gap-2" data-id="element-437">
                <span className="text-gold" data-id="element-438">✦</span> Trabajo con péndulo hebreo
              </li>
              <li className="flex items-start gap-2" data-id="element-439">
                <span className="text-gold" data-id="element-440">✦</span> Investigación radiestésica
                completa del campo áurico
              </li>
              <li className="flex items-start gap-2" data-id="element-441">
                <span className="text-gold" data-id="element-442">✦</span> Detección de patrones,
                capas y orígenes
              </li>
              <li className="flex items-start gap-2" data-id="element-443">
                <span className="text-gold" data-id="element-444">✦</span> Depuración profunda y
                precisa
              </li>
              <li className="flex items-start gap-2" data-id="element-445">
                <span className="text-gold" data-id="element-446">✦</span> Audio de devolución
                personalizado (aprox. 1 hora)
              </li>
            </ul>
            <div className="border-t border-white/20 pt-6 mb-8" data-id="element-447">
              <div className="text-white font-medium text-lg mb-1" data-id="element-448">
                🇦🇷 $115.000 ARS
              </div>
              <div className="text-white font-medium text-lg" data-id="element-449">
                🌎 USD 90 vía PayPal
              </div>
            </div>
            <div className="border-t border-white/20 pt-6 mb-8" data-id="element-450">
              <div className="text-gold font-medium text-lg mb-1" data-id="element-451">
                PARA QUIÉN ES
              </div>
              <div className="text-white/90 font-light italic" data-id="element-452">
                Quienes llevan tiempo buscando respuestas. Quienes sienten que
                su situación tiene capas que una depuración general no alcanza.
                Quienes quieren entender, no solo sentir alivio.
              </div>
            </div>
            <a href="https://wa.me/542616167908?text=Hola%20Laura!%20Quiero%20agendar%20una%20sesi%C3%B3n%20de%20Depuraci%C3%B3n%20%2B%20Investigaci%C3%B3n%20Radiest%C3%A9sica." target="_blank" rel="noopener noreferrer" className="w-full text-center bg-white text-teal py-4 rounded-full font-medium tracking-wide hover:bg-cream transition-colors" data-id="element-453">
              AGENDAR SESIÓN
            </a>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col bg-white border border-teal rounded-2xl p-8 relative" data-id="element-454">
            <div className="w-14 h-14 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-455">
              <BookOpen className="text-teal" size={26} strokeWidth={1.5} data-id="element-456" />
            </div>
            <div className="text-teal font-serif uppercase tracking-widest text-xs mb-6" data-id="element-457">
              La sesión más completa
            </div>
            <h3 className="font-serif text-teal text-2xl mb-4" data-id="element-458">
              Depuración + Investigación + Registros Akáshicos
            </h3>
            <p className="text-gray-700 font-light mb-8 flex-grow leading-relaxed" data-id="element-459">
              El trabajo más completo que realizo. Investigación radiestésica
              del campo, depuración profunda, y apertura de los Registros
              Akáshicos.
              <br data-id="element-460" />
              <br data-id="element-461" />
              Los Registros Akáshicos son la memoria vibracional de tu alma. En
              ellos está registrado no solo lo que viviste — sino los patrones
              que permanecen activos y que explican por qué ciertas cosas se
              repiten aunque hayas trabajado mucho en vos mismo/a.
            </p>
            <ul className="space-y-3 text-gray-700 font-light mb-8" data-id="element-462">
              <li className="flex items-start gap-2" data-id="element-463">
                <span className="text-gold" data-id="element-464">✦</span> Todo lo incluido en el
                nivel anterior
              </li>
              <li className="flex items-start gap-2" data-id="element-465">
                <span className="text-gold" data-id="element-466">✦</span> Apertura de Registros
                Akáshicos con radiestesia
              </li>
              <li className="flex items-start gap-2" data-id="element-467">
                <span className="text-gold" data-id="element-468">✦</span> Información del alma —
                patrones, contratos, programas
              </li>
              <li className="flex items-start gap-2" data-id="element-469">
                <span className="text-gold" data-id="element-470">✦</span> Audio de devolución
                personalizado (el más extenso)
              </li>
            </ul>
            <div className="border-t border-teal/20 pt-6 mb-8" data-id="element-471">
              <div className="text-teal font-medium text-lg mb-1" data-id="element-472">
                🇦🇷 $160.000 ARS
              </div>
              <div className="text-teal font-medium text-lg" data-id="element-473">
                🌎 USD 130 vía PayPal
              </div>
            </div>
            <div className="border-t border-teal/20 pt-6 mb-8" data-id="element-474">
              <div className="text-teal font-medium text-lg mb-1" data-id="element-475">
                PARA QUIÉN ES
              </div>
              <div className="text-gray-700 font-light italic" data-id="element-476">
                Quienes repiten patrones a pesar de todo el trabajo realizado.
                Quienes sienten que hay algo que va más allá de esta historia
                consciente. Quienes no buscan solo alivio — buscan comprender
                desde el origen.
              </div>
            </div>
            <a href="https://wa.me/542616167908?text=Hola%20Laura!%20Quiero%20agendar%20una%20sesi%C3%B3n%20de%20Depuraci%C3%B3n%20%2B%20Investigaci%C3%B3n%20%2B%20Registros%20Ak%C3%A1shicos." target="_blank" rel="noopener noreferrer" className="w-full text-center bg-teal text-white py-4 rounded-full font-medium tracking-wide hover:bg-teal-dark transition-colors" data-id="element-477">
              AGENDAR SESIÓN
            </a>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-gray-500 text-sm font-light" data-id="element-478">
          Pagos en Argentina: transferencia bancaria o Mercado Pago
          <br data-id="element-479" />
          Pagos internacionales: PayPal en USD
        </motion.p>
      </div>
    </section>;
}